export { default as pipelinesQueries } from './pipelines'
export { default as tasksQueries } from './tasks'